import React, { createContext, useContext } from 'react';

import { Divider, Tooltip, Paper } from '@material-ui/core';
import { ToggleButtonGroup } from '@material-ui/lab';
import { withStyles, makeStyles } from '@material-ui/styles';
import { StyledTypography, StyledToggleButton, FlexContainer, VerticallyAlignedFlexContainer } from 'styles/common';

import { TEAM_TASKS_VIEW_NAMES } from 'constants/ProjectConstants';
import { StyledIcon } from 'constants/icons';
import { KH_LINKS } from 'constants/knowledgeHubLinks';

import TooltipInfo from 'uiToolkit/TooltipInfo';

import { ViewTypesContainer } from './styles';

const useStyles = makeStyles((theme) => ({
  paper: {
    display: 'flex',
    flexWrap: 'wrap',
    border: `2px solid ${theme.palette.borders.lighterGrey}`,
  },
  divider: {
    margin: theme.spacing(1, 0.5),
  },
}));

const ViewTypeContext = createContext({ teamTasksViewType: '', handleTeamViewTypeChange: null });

function ViewTypeDisplay() {
  const { teamTasksViewType } = useContext(ViewTypeContext);
  return (
    <StyledTypography rightGutter={2} display="inline" style={{ 'min-width': '80px' }}>
      {TEAM_TASKS_VIEW_NAMES[teamTasksViewType]}
    </StyledTypography>
  );
}

export default function ViewTypes({ className, teamTasksViewType, handleTeamViewTypeChange, children }) {
  const context = { teamTasksViewType, handleTeamViewTypeChange };
  return (
    <ViewTypeContext.Provider value={context}>
      <ViewTypesContainer className={className}>{children}</ViewTypesContainer>
    </ViewTypeContext.Provider>
  );
}

export function Toggles({ children, hideOnlyExistingToggle = false }) {
  const { teamTasksViewType, handleTeamViewTypeChange } = useContext(ViewTypeContext);
  const classes = useStyles();

  return (
    <VerticallyAlignedFlexContainer>
      {!hideOnlyExistingToggle && (
        <Paper elevation={0} className={classes.paper}>
          <ToggleButtonGroup size="small" value={teamTasksViewType} exclusive onChange={handleTeamViewTypeChange}>
            {children}
          </ToggleButtonGroup>
        </Paper>
      )}
      <TooltipInfo
        title={KH_LINKS.TEAMHUB_VIEW.description}
        linkUrl={KH_LINKS.TEAMHUB_VIEW.url}
        leftGutter={hideOnlyExistingToggle ? 0 : 1}
      />
    </VerticallyAlignedFlexContainer>
  );
}

export function ViewTypeToggle({ selected, onChange, value, icon, isLast = false, disabled = false }) {
  // const { teamTasksViewType } = useContext(ViewTypeContext);
  const classes = useStyles();

  if (disabled) {
    return null;
  }

  return (
    <StyledTooltip title={`${value?.toLowerCase()} view${disabled ? '(Not Supported)' : ''}`}>
      <FlexContainer>
        <StyledToggleButton selected={selected} onChange={onChange} value={value} disabled={disabled}>
          <StyledIcon
            // onClick={() => setTeamTasksViewType(TEAM_TASKS_VIEW_TYPES.card)}
            size="tiny"
            color={selected ? 'primary' : 'textSecondary'}
          >
            {icon}
          </StyledIcon>
        </StyledToggleButton>
        {!isLast && (
          <Divider
            flexItem
            orientation="vertical"
            style={{ marginTop: 'auto', marginBottom: 'auto', height: '50%' }}
            className={classes.divider}
          />
        )}
      </FlexContainer>
    </StyledTooltip>
  );
}

ViewTypes.Toggles = Toggles;
ViewTypes.ViewTypeDisplay = ViewTypeDisplay;

Toggles.Toggle = ViewTypeToggle;

const StyledTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: theme.palette.blue.toolTip,
    fontSize: '0.9rem',
    textTransform: 'capitalize',
  },
}))(Tooltip);
